var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slingshot-wrapper"},[_c('div',{ref:"slingshotContainer",staticClass:"slingshot-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }